import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import CSSTransition from 'react-transition-group/CSSTransition';

import Icon from '../Icon';
import Message from '../Message';
import Button from '../Button';
import styles from './styles.css';

const ToastKind = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error',
};

const Timeouts = {
  enter: 200,
  exit: 700,
  show: 5000,
};

export default class Toast extends PureComponent {
  static propTypes = {
    mountNode: PropTypes.any,
    active: PropTypes.bool.isRequired,
    onDeactivate: PropTypes.func.isRequired,
    title: PropTypes.any,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    kind: PropTypes.oneOf(Object.values(ToastKind)),
  };

  static defaultProps = {
    kind: 'success',
  };

  constructor(props) {
    super(props);

    this.activeTimeoutId = 0;
    if (props.active) {
      this.activate();
    }
  }

  componentWillUnmount() {
    this.clearActiveTimeout();
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps({ active }) {
    if (active !== this.props.active) {
      if (active) {
        this.activate();
      } else {
        this.clearActiveTimeout();
      }
    }
  }

  onDismiss = () => {
    this.clearActiveTimeout();
    this.props.onDeactivate();
  };

  get iconName() {
    switch (this.props.kind) {
      case ToastKind.error:
        return 'remove circle';
      case ToastKind.warning:
        return 'warning circle';
      case ToastKind.info:
        return 'info circle';
      case ToastKind.success:
      default:
        return 'check circle';
    }
  }

  get messageProps() {
    const { kind } = this.props;
    return {
      success: kind === ToastKind.success,
      error: kind === ToastKind.error,
      warning: kind === ToastKind.warning,
      info: kind === ToastKind.info,
    };
  }

  clearActiveTimeout() {
    /* istanbul ignore else */
    if (this.activeTimeoutId !== 0) {
      clearTimeout(this.activeTimeoutId);
      this.activeTimeoutId = 0;
    }
  }

  activate() {
    /* istanbul ignore else */
    if (this.activeTimeoutId === 0) {
      this.activeTimeoutId = setTimeout(() => {
        this.props.onDeactivate();
        this.activeTimeoutId = 0;
      }, Timeouts.show);
    }
  }

  render() {
    const { title, description, mountNode, active } = this.props;

    return ReactDOM.createPortal((
      <CSSTransition
        in={active}
        appear
        classNames={styles}
        enter={false}
        timeout={Timeouts}
        unmountOnExit
      >
        <div styleName="toast" data-cy="toast">
          <Message
            {...this.messageProps}
            size="small"
            className="toast"
            icon
          >
            <Button basic icon color="black" className="close" data-cy="toast-close-button" onClick={this.onDismiss}>
              <Icon name="close" />
            </Button>
            <Icon name={this.iconName} />
            <Message.Content>
              <Message.Header>{title}</Message.Header>
              <p>{description}</p>
            </Message.Content>
          </Message>
        </div>
      </CSSTransition>
    ), mountNode || document.body);
  }
}
